<template>
  <div>
    Da ist ein Fehler aufgetreten - das sollte nicht passieren.<br/>
    Bitte laden Sie die Seite erneut oder probieren Sie es später erneut.
  </div>
</template>

<script>
export default {
  name: "ErrorComponent"
}
</script>

<style>

</style>
